import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { Subdependencia, Dependencia, Bitacora, ComprobanteE } from './entidades';
import { prueba } from './components/informe/informe.component';

@Injectable({
  providedIn: 'root'
})
export class FinanzasService {

constructor(private _httpClient: HttpClient) { }

/* ------------------------------------------------------------   
              GET - 
 -------------------------------------------------------------- */

  public getEmpresas(){
    return this._httpClient.get(`${environment.api}finanzas/empresas`)
  }

  public getEmpresaId(id_empresa){
    return this._httpClient.get(`${environment.api}finanzas/empresas/${id_empresa}`)
  }

  public getPuc(idEmpresa){
    return this._httpClient.get(`${environment.api}finanzas/puc/${idEmpresa}`)
  }

  public getPucId(idEmpresa, id){
    return this._httpClient.get(`${environment.api}finanzas/pucId/${idEmpresa}/${id}` )
  }

  public getArea() {
    return this._httpClient.get(`${environment.api}finanzas/area`)
  }

  public getUsuarios(area, dependencia, subdependencia){
    return this._httpClient.get(`${environment.api}finanzas/usuarios/${area}/${dependencia}/${subdependencia}`);
  }

  public getUsuarios_filter(area, dependencia ){
    return this._httpClient.get(`${environment.api}finanzas/usuarios_filter/${area}/${dependencia}`);
  }

  public getDependencias(area):Observable< Array<Dependencia> > {
    return this._httpClient.get<  Array<Dependencia> >(`${environment.api}finanzas/dependencia/${area}`);
  }

  public getSubdependencias(dependencia):Observable< Array<Subdependencia> >  {
    return this._httpClient.get<Array<Subdependencia>>(`${environment.api}finanzas/subdependencias/${dependencia}`);
  }

  public getMeses(id_mes){
    return this._httpClient.get(`${environment.api}finanzas/meses/${id_mes}`)
  }

  public getBitacoraId(id_gasto){
    return this._httpClient.get(`${environment.api}finanzas/movimientos/bitacora/${id_gasto}`)
  }

  // trae de la tabla finanzasmc 
  public  filtro_mto_empresa( id_empresa, anio, mes ):Observable<{gastos:Array<Bitacora>, ingresos:Array<Bitacora>}> {
    return this._httpClient.get<{ gastos: Array<Bitacora>, ingresos: Array<Bitacora> }>(`${environment.api}finanzas/movimientos/bitacora/filtro/${id_empresa}/${anio}/${mes}`);
  }
  public  filtro_anio( id_empresa, anio  ) :Observable<{gastos:Array<Bitacora>, ingresos:Array<Bitacora>}>   {
    return this._httpClient.get<{ gastos: Array<Bitacora>, ingresos: Array<Bitacora> }>(`${environment.api}finanzas/movimientos/bitacora/filtro_anio/${id_empresa}/${anio}`);
  }

  public gastos(id_empresa, anio, mes){
    return this._httpClient.get(`${environment.api}finanzas/gastosMes/${id_empresa}/${anio}/${mes}`)
  }

  public operacion3(anio, id_empresa):Observable<{ ingresos:Array<prueba> }> {
    return this._httpClient.get<{ ingresos:Array<prueba> }>(`${environment.api}finanzas/operacion3/${anio}/${id_empresa}`)
  }

  public operacion4(anio, id_empresa): Observable<{ gastos: Array<prueba> }> {
    return this._httpClient.get<{ gastos: Array<prueba> }>(`${environment.api}finanzas/operacion3/${anio}/${id_empresa}`)
  }

  // Datos para las graficas

  public ingresosF(id_empresa, anio){
    return this._httpClient.get(`${environment.api}finanzas/ingresos/fortuitos/${anio}/${id_empresa}`);
  }

  public ingresosR(id_empresa, anio){
    return this._httpClient.get(`${environment.api}finanzas/ingresos/rutinarios/${anio}/${id_empresa}`);
  }
  
  public gastosR(id_empresa, anio){
    return this._httpClient.get(`${environment.api}finanzas/gastos/rutinarios/${anio}/${id_empresa}`)
  }

  public gastosF(id_empresa, anio){
    return this._httpClient.get(`${environment.api}finanzas/gastos/fortuitos/${anio}/${id_empresa}`)
  }

  //  Datos para las graficas por area
  
 

  public operativaG(id_empresa, anio) {
    return this._httpClient.get(`${environment.api}finanzas/gastos/serviClient/${anio}/${id_empresa}`)
  }

  public administrativaG(id_empresa, anio) {
    return this._httpClient.get(`${environment.api}finanzas/gastos/administrativa/${anio}/${id_empresa}`)
  }

  public comercialG(id_empresa, anio) {
    return this._httpClient.get(`${environment.api}finanzas/gastos/comercial/${anio}/${id_empresa}`)
  }

  public serviClientG(id_empresa, anio) {
    return this._httpClient.get(`${environment.api}finanzas/gastos/serviClient/${anio}/${id_empresa}`)
  }

  public talentoG(id_empresa, anio) {
    return this._httpClient.get(`${environment.api}finanzas/gastos/talento/${anio}/${id_empresa}`)
  }





/*  ----------------------------------------------------------------  
              PUT -
  ------------------------------------------------------------------ */

  public borrarCuentaPuc(form, id){
    return this._httpClient.put(`${environment.api}finanzas/puc/borrarCuenta/${id}`, form)
  }

  public borrarBitacora(form,  id_gasto){
    return this._httpClient.put(`${environment.api}finanzas/movimientos/borrarBitacora/${id_gasto}`, form  )
  }

  public actualizarRegistro(form, id_gasto){
    return this._httpClient.put(`${environment.api}finanzas/movimientos/updateBitacora/${id_gasto}`, form);
  }

  public editarPuc(form, id){
    return this._httpClient.put(`${environment.api}finanzas/puc/editarPuc/${id}` , form)
  }

  public relacionGastos(form, id_gasto){
    return this._httpClient.put(`${environment.api}finanzas/movimientos/relacionarGastos/${id_gasto}`, form)  }






  /*  ----------------------------------------------------------------  
              POST -
  ------------------------------------------------------------------ */

  public addCuenta(form){
    return this._httpClient.post(`${environment.api}finanzas/puc/addCuenta/`, form);
  }

  public insertarRegistro(form) {
    return this._httpClient.post(`${environment.api}finanzas/movimientos/bitacora/insertregistro`, form );
  }


  


  /*  ----------------------------------------------------------------  
            ENDPOINT COMPROBANTE DE EGRESO 
  ------------------------------------------------------------------ */

  /*  ----------------------------------------------------------------  
              GET -
  ------------------------------------------------------------------ */
  
  

  public tipoComprobante(){
    return this._httpClient.get(`${environment.api}finanzas/comprobante/tipoComprobantes/all`);
  }

  public filtroComprobante(id_empresa, anio, mes)  {
    return this._httpClient.get(`${environment.api}finanzas/comprobante/filtroComprobante/${id_empresa}/${anio}/${mes}`);
  }
  
  public filtroComprobanteAnio(id_empresa, anio){
    return this._httpClient.get(`${environment.api}finanzas/comprobante/bitacora/filtroAnio/${id_empresa}/${anio}`);
  }

  public ComprobanteId(idComprobante){
    return this._httpClient.get(`${environment.api}finanzas/comprobante/bitacora/${idComprobante}`);
  }

  public diferencia1(empresa, anio, mes ){
    return this._httpClient.get(`${environment.api}finanzas/comprobante/operacion1/${empresa}/${anio}/${mes}` )
  }

  public diferencia2(empresa, anio ){
    return this._httpClient.get(`${environment.api}finanzas/comprobante/operacion2/${empresa}/${anio}` )

  }

  // 
  public totalIMes(id_empresa, anio){
    return this._httpClient.get(`${environment.api}finanzas/totalMesI/${anio}/${id_empresa}`)
  }

  public totalMesG(id_empresa, anio ){
    return this._httpClient.get(`${environment.api}finanzas/totalMesG/${anio}/${id_empresa}`)
  }

  /*  ----------------------------------------------------------------  
              POST -
  ------------------------------------------------------------------ */

  public insertComprobante(form ){
    return this._httpClient.post(`${environment.api}finanzas/comprobante/bitacora/insertComprobante`, form )
  }






  /*  ----------------------------------------------------------------  
              PUT -
  ------------------------------------------------------------------ */

  public updateComprobante(form, idComprobante){
    return this._httpClient.put(`${environment.api}finanzas/comprobante/bitacora/updateComprobante/${idComprobante}`, form)
  }

  public borrarBitacoraCE(form, idComprobante){
    return this._httpClient.put(`${environment.api}finanzas/comprobante/borrarComprobante/${idComprobante}`, form )
  }





}



